import React, { Component } from "react";
import { Field, Form, withFormik } from "formik";
import classes from "./NewsForm.module.css";
import * as Yup from "yup";
import Aux from "../../../../hoc/Auxilary";
import { Button } from "rsuite";

class NewsForm extends Component {
  render() {
    const validAndHandle = (func, values) => {
      this.props.validateForm().then(errors => {
        console.log("errors", errors);

        if (Object.keys(errors).length !== 0) {
            this.props.setFieldTouched("news_url", true);
            this.props.setFieldTouched("news_title", true);
            this.props.setFieldTouched("news_date", true);
            console.log("cannot submit! Validation failed", errors);
        } else {
          values.project_id = this.props.projectID;
          func(values);
          this.props.resetForm();
          this.props.toggleSmallModalHandler();
        }
      });
    };

    return (
      <Form className={classes.NewsForm}>
          <fieldset disabled={this.props.disabled}>
              <small className={"d-block col-12"}><span style={{color:"red"}}>*</span> required</small>
              <div className={"d-inline-block col-12"}>
            <label
                className={"required"}
                style={this.props.errors.news_url && this.props.touched.news_url && {color: "red"}}>
              News Url
            </label>
              <Field
                  style={this.props.errors.news_url && this.props.touched.news_url && {borderColor: "red"}}
                  component={"textarea"}
                  className="form-control" name={"news_url"} value={this.props.values.news_url || ""} />
                  {this.props.errors.news_url && this.props.touched.news_url && (
                      <small className="text-danger">{this.props.errors.news_url}</small>
                  )}
              </div>


            <div className={"d-inline-block col-12"}>
            <label
                style={this.props.errors.news_title && this.props.touched.news_title && {color: "red"}}
                className={"required"}>
              News Title
            </label>
              <Field
                  style={this.props.errors.news_title && this.props.touched.news_title && {borderColor: "red"}}
                  className="form-control"
                     component={"textarea"}
                name={"news_title"}
                value={this.props.values.news_title || ""}
              />
                {this.props.errors.news_title && this.props.touched.news_title && (
                    <small className="text-danger">{this.props.errors.news_title}</small>
                )}

            </div>

            <div className={"d-inline-block col-12"}>
            <label
                style={this.props.errors.news_date && this.props.touched.news_date && {color: "red"}}
                className={"required"}>
              News Date (Format: YYYY-MM-DD)
            </label>
              <Field
                  style={this.props.errors.news_date && this.props.touched.news_date && {borderColor: "red"}}
                  className="form-control"
                  name={"news_date"}
                  value={this.props.values.news_date || ""} />
              {this.props.errors.news_date && this.props.touched.news_date && (
                <small className="text-danger">{this.props.errors.news_date}</small>
              )}
            </div>

            {/*<label className={"col-12"}>*/}
              {/*News File Link*/}
              {/*<Field*/}
                  {/*component={"textarea"}*/}
                  {/*className="form-control"*/}
                {/*name={"news_file_link"}*/}
                {/*value={this.props.values.news_file_link || ""}*/}
              {/*/>*/}
            {/*</label>*/}

            <label className={"col-12"}>
              News Publisher
              <Field
                  component={"textarea"}
                  className="form-control"
                name={"news_publisher"}
                value={this.props.values.news_publisher || ""}
              />
            </label>

            <label className={"col-12"}>
              News Author
              <Field className="form-control"
                name={"news_author"}
                value={this.props.values.news_author || ""}
              />
            </label>
          </fieldset>

          {this.props.disabled ? (
              <Button className="ml-2" type="button" onClick={this.props.toggleSmallModalHandler}>
                  Cancel
              </Button>) : (
              <div>
                {!this.props.currentNews ? (
                  <Button
                      color={"blue"}
                    type="button"
                    onClick={() => {
                      validAndHandle(this.props.add, this.props.values);
                    }}
                  >
                    Submit
                  </Button>
                ) : (
                  <Aux>
                    <Button
                        color={"blue"}
                      type="button"
                      onClick={() => {
                        validAndHandle(this.props.update, this.props.values);
                      }}
                    >
                      Update
                    </Button>
                  </Aux>
                )}
                  <Button className="ml-2" color={"red"} type="button" onClick={this.props.handleReset}>
                      Reset
                  </Button>
                  <Button className="ml-2" type="button" onClick={this.props.toggleSmallModalHandler}>
                      Cancel
                  </Button>
              </div>
              )}
      </Form>
    );
  }
}

var newsSchema = Yup.object().shape({
  news_url: Yup.string().required(),
  news_title: Yup.string().required(),
  news_date: Yup.date().typeError("Must be a date type").required(),
});

export default withFormik({
  validationSchema: newsSchema,

  mapPropsToValues({ currentNews }) {
    return {
      ...currentNews
    };
  }
})(NewsForm);
